import { useEffect, useState } from "react";
import useAxios from '../../../hooks/useAxios';

const Shipping = () => {
    const { AxiosPrivate } = useAxios()
    const [price, setPrice] = useState({})

    useEffect(() => {
        const get = async () => {
            await AxiosPrivate.get('/shipping-cost')
                .then(res => setPrice(res.data.data))
                .catch(err => alert(err.response?.data.message))
        }
        get()
    }, [])

    const handleChange = ({ target }) => {
        const { name, value } = target
        setPrice(prev => ({ ...prev, [name]: value }))
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        await AxiosPrivate.put('/shipping-cost/update', price)
            .then(res => alert(res.data.message))
            .catch(err => alert(err.response?.data.message))
    }

    return (
        <>
            <div className="p-2">
                <form className="flex gap-6 flex-col items-start" onSubmit={handleSubmit}>
                    <div className="flex items-center gap-6">
                        <div className="flex items-center gap-4">
                            <div className="relative">
                                <input type="number" id="1" name="tehran" defaultValue={price.tehran} onChange={handleChange}
                                    className={`block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-lg border-1 appearance-none dark:text-white focus:outline-none focus:ring-0 peer`} placeholder="" />
                                <label htmlFor='1' className={`absolute text-nowrap rounded-lg text-sm duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto`}>تهران</label>
                            </div>
                            <span>تومان</span>
                        </div>
                        <div className="flex items-center gap-4">
                            <div className="relative">
                                <input type="number" id="2" name="other" defaultValue={price.other} onChange={handleChange}
                                    className={`block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-lg border-1 appearance-none dark:text-white focus:outline-none focus:ring-0 peer`} placeholder="" />
                                <label htmlFor='2' className={`absolute text-nowrap rounded-lg text-sm duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto`}>سایر شهر ها</label>
                            </div>
                            <span>تومان</span>
                        </div>
                    </div>
                    <div className="w-full flex sm:items-center items-start gap-4 sm:text-base text-sm sm:flex-row flex-col">
                        <p>ویرایش: {new Date(price.updated_at).toLocaleString('fa-IR')}</p>
                    </div>
                    <button className="text-white me-3 bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br  focus:outline-none shadow-lg shadow-blue-500/50 dark:shadow-lg dark:shadow-blue-800/80 font-medium rounded-lg text-sm px-5 py-2.5 text-center">ویرایش</button>
                </form>
            </div>
        </>
    );
};

export default Shipping;